import { iconsSources } from '../../helpers/icons';
import styles from './Message.module.css';

import lightningRight from '../../assets/images/lightningRight.png';
import lightningLeft from '../../assets/images/lightningLeft.png';

const Message = ({
  message,
  titrTag,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  win,
  currentState,
  winId,
  winIds,
}) => {
  const isWinner = winId === message.id && currentState === 'S4';

  let reg =
    /(?<!\d)[\+]?(?:(?:7|8)?[\s\.\-]?\(?\d{3,5}\)?[\s\.\-]?)??\d{2,3}[\s\.\-]?\d{2}[\s\.\-]?\d{2}(?:[\s\.\-]?\d{2})?(?!\d)/g;

  let text = message?.content.trim().replace(reg, '');

  return (
    <div className={styles['wrapper']}>
      {message && (
        <div className={`${styles['blockMsg']}`}>
          <div
            className={`${styles['nameAuthor']} ${
              isWinner && styles['winnerBg']
            }`}
          >
            {/* <div
              className={styles.author}
              style={{ fontSize: `${authorFontSize}rem` }}
            >
              {message.author}
            </div> */}
            <div
              className={styles['text']}
              style={{ fontSize: `${msgFontSize}rem` }}
            >
              {text}
            </div>

            {isWinner && (
              <>
                <div className={`${styles.lightning} ${styles.left}`}>
                  <img src={lightningLeft} alt="lightningLeft" />
                </div>
                <div className={`${styles.lightning} ${styles.right}`}>
                  <img src={lightningRight} alt="lightningRight" />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
